// regenerator-runtime and core-js implement most polyfills for older browsers
import "regenerator-runtime";
import "core-js";

import "trusted-types/dist/es5/trustedtypes.build"; // trusted-types polyfill for browsers that don't yet support it
import "whatwg-fetch"; // fetch polyfill for using the fetch API in older browsers

import { boot, IRcaBootConfig } from "./app";

// This is the main entrypoint of starting up the application
void (async () => {
  const apiVersion = "v1.0";

  // Fetch the current boot config
  const response = await fetch(`/api/${apiVersion}/settings/boot`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch boot configuration.");
  }

  const config = (await response.json()) as IRcaBootConfig;

  // Perform the boot
  await boot(apiVersion, config);
})();
